import {
    GET_ALL_BOOKING_LOGS_FAILURE,
    GET_ALL_BOOKING_LOGS_REQUEST,
  GET_ALL_BOOKING_LOGS_SUCCESS,
  GET_ALL_MAIN_REPORTS_FAILURE,
  GET_ALL_MAIN_REPORTS_REQUEST,
  GET_ALL_MAIN_REPORTS_SUCCESS,
  GET_FINANCIAL_REPORTS_FAILURE,
  GET_FINANCIAL_REPORTS_REQUEST,
  GET_FINANCIAL_REPORTS_SUCCESS,
  GET_OFFICE_REPORTS_FAILURE,
  GET_OFFICE_REPORTS_REQUEST,
  GET_OFFICE_REPORTS_SUCCESS,
  GET_PAYMENT_METHODS_REPORT_REQUEST,
  GET_PAYMENT_METHODS_REPORT_SUCCESS,
  GET_PAYMENT_METHODS_REPORT_FAILURE,
} from "../../../Utils/Constant";

// Get All Reservation List Details
export const getOfficeReportsRequest = (payload) => {
  return {
    type: GET_OFFICE_REPORTS_REQUEST,
    payload,
  };
};

export const getOfficeReportsSuccess = (data) => {
  return {
    type: GET_OFFICE_REPORTS_SUCCESS,
    payload: data,
  };
};

export const getOfficeReportsFailure = (error) => {
  return {
    type: GET_OFFICE_REPORTS_FAILURE,
    payload: error,
  };
};


/// Financial reports 

export const getFinancialReportsRequest = (payload) => {
  return {
    type: GET_FINANCIAL_REPORTS_REQUEST,
    payload,
  };
};

export const getFinancialReportsSuccess = (data) => {
  return {
    type: GET_FINANCIAL_REPORTS_SUCCESS,
    payload: data,
  };
};

export const getFinancialReportsFailure = (error) => {
  return {
    type: GET_FINANCIAL_REPORTS_FAILURE,
    payload: error,
  };
};

// get all main reports for report page 

export const getAllMainReportsRequest = (payload) => {
  return {
    type: GET_ALL_MAIN_REPORTS_REQUEST,
    payload,
  };
};

export const getAllMainReportsSuccess = (data) => {
  return {
    type: GET_ALL_MAIN_REPORTS_SUCCESS,
    payload: data,
  };
};

export const getAllMainReportsFailure = (error) => {
  return {
    type: GET_ALL_MAIN_REPORTS_FAILURE,
    payload: error,
  };
};

export const getPaymentMethodsReportRequest = (payload) => ({
  type: GET_PAYMENT_METHODS_REPORT_REQUEST,
  payload,
});

export const getPaymentMethodsReportSuccess = (data) => ({
  type: GET_PAYMENT_METHODS_REPORT_SUCCESS,
  payload: data,
});

export const getPaymentMethodsReportFailure = (error) => ({
  type: GET_PAYMENT_METHODS_REPORT_FAILURE,
  payload: error,
});

export const getRecentNotificationsRequest = () => ({
  type: "GET_RECENT_NOTIFICATIONS_REQUEST"
});

export const getRecentNotificationsSuccess = (data) => ({
  type: "GET_RECENT_NOTIFICATIONS_SUCCESS",
  payload: data
});

export const getRecentNotificationsFailure = (error) => ({
  type: "GET_RECENT_NOTIFICATIONS_FAILURE",
  payload: error
}); 